import { createContext, useCallback, useContext, useState } from 'react'

type SaveIndicatorState = {
  isDirty: boolean
  isError: boolean
  isSaving: boolean
  reset: () => void
  setIsDirty: (isDirty: boolean) => void
  setIsError: (error: boolean) => void
  setIsSaving: (isSaving: boolean) => void
}

const DEFAULT_VALUES = {
  isDirty: false,
  isError: false,
  isSaving: false,
  reset: () => {},
  setIsDirty: () => {},
  setIsError: () => {},
  setIsSaving: () => {},
} as SaveIndicatorState

export const SaveIndicatorContext = createContext<SaveIndicatorState>(DEFAULT_VALUES)

type SaveIndicatorProviderProps = {
  children: React.ReactNode
}

export const SaveIndicatorProvider = ({ children }: SaveIndicatorProviderProps) => {
  const [isDirty, setIsDirty] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  const reset = useCallback(() => {
    setIsDirty(false)
    setIsError(false)
    setIsSaving(false)
  }, [])

  return (
    <SaveIndicatorContext.Provider
      value={{
        isDirty,
        isError,
        isSaving,
        reset,
        setIsDirty,
        setIsError,
        setIsSaving,
      }}
    >
      {children}
    </SaveIndicatorContext.Provider>
  )
}

export const useSaveIndicator = () => useContext(SaveIndicatorContext)
